var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIcons8Contacts(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    fill: "#000000",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    width: "24px",
    height: "24px",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M 6 2 C 4.897 2 4 2.897 4 4 L 4 20 C 4 21.103 4.897 22 6 22 L 18 22 C 19.103 22 20 21.103 20 20 L 20 4 C 20 2.897 19.103 2 18 2 L 6 2 z M 6 4 L 18 4 L 18 20 L 6 20.001953 L 6 4 z M 12 6 C 10.318 6 9 7.317 9 9 C 9 10.683 10.318 12 12 12 C 13.682 12 15 10.683 15 9 C 15 7.317 13.682 6 12 6 z M 12 8 C 12.58 8 13 8.421 13 9 C 13 9.579 12.58 10 12 10 C 11.42 10 11 9.579 11 9 C 11 8.421 11.42 8 12 8 z M 12 13 C 9.149 13 7 14.455766 7 16.384766 L 7 18 L 17 18 L 17 16.384766 C 17 14.455766 14.851 13 12 13 z M 12 15 C 13.47 15 14.489516 15.504 14.853516 16 L 9.1464844 16 C 9.5094844 15.504 10.53 15 12 15 z"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcons8Contacts);
export default __webpack_public_path__ + "static/media/icons8-contacts.814a3358.svg";
export { ForwardRef as ReactComponent };